import React, { FC } from 'react';
import { LayoutProps, useTranslate } from '@refinedev/core';
import { Col, Layout as AntdLayout, Row } from 'antd';
import { Header } from '../../../header';
import { Footer } from '../../../footer';
import Container from '../../../container';
import { CompanyLogo } from '../../../../company-logo';
import { NavigationMenu } from '../../../navigation-menu';
import { useMenuItems } from '../../../header/useMenuItems';
import styles from '../../Layout.module.scss';
import AccessibilityToolbar from '../../../../AccessibilityToolbar';

export const Layout: FC<LayoutProps> = ({ children }) => {
    const t = useTranslate();
    const menuItems = useMenuItems();

    return (
        <AntdLayout className={styles.layout}>
            <AccessibilityToolbar />
            <Header />

            <AntdLayout.Content className={styles.contentInternal}>
                <div className={styles.internalContent}>{children}</div>
            </AntdLayout.Content>

            <Footer>
                <Container max={1580} padX={35}>
                    <Row align="middle" gutter={[50, 0]}>
                        <Col flex="0 0 auto">
                            <CompanyLogo
                                href="/"
                                src="/images/moz.svg"
                                alt={t(
                                    'pages.login.state_enterprise_state_expert_center_of_the_ministry_of_health_of_ukraine_description'
                                )}
                                width={100}
                                height={48}
                                className={styles.logo}
                            />
                        </Col>
                        <Col flex={5}>
                            <NavigationMenu
                                items={menuItems}
                                variant="muted"
                                dropdownPlacement="up"
                            />
                        </Col>
                    </Row>
                </Container>
            </Footer>
        </AntdLayout>
    );
};

export default Layout;
